export const CRYPTO = 2;
export const FIAT = 3;

export const TYPES = {
    [CRYPTO]: 'Crypto',
    [FIAT]: 'Fiat',
}
